export default "__VITE_ASSET__pg4Kc_CY__"